var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 15,
    viewBox: "0 0 85 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32759 0L8.97273 5.06324H14.2965L9.98949 8.19249L11.6346 13.2557L7.32759 10.1265L3.02054 13.2557L4.66568 8.19249L0.358638 5.06324H5.68244L7.32759 0Z",
    fill: "#FFD400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9138 0L26.5589 5.06324H31.8827L27.5757 8.19249L29.2208 13.2557L24.9138 10.1265L20.6067 13.2557L22.2519 8.19249L17.9448 5.06324H23.2686L24.9138 0Z",
    fill: "#FFD400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4999 0L44.1451 5.06324H49.4689L45.1619 8.19249L46.807 13.2557L42.4999 10.1265L38.1929 13.2557L39.838 8.19249L35.531 5.06324H40.8548L42.4999 0Z",
    fill: "#FFD400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0863 0L61.7314 5.06324H67.0552L62.7482 8.19249L64.3933 13.2557L60.0863 10.1265L55.7792 13.2557L57.4244 8.19249L53.1173 5.06324H58.4411L60.0863 0Z",
    fill: "#FFD400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6724 0L79.3176 5.06324H84.6414L80.3343 8.19249L81.9795 13.2557L77.6724 10.1265L73.3654 13.2557L75.0105 8.19249L70.7035 5.06324H76.0273L77.6724 0Z",
    fill: "#FFD400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartsImg);
export default __webpack_public_path__ + "static/media/startsImg.14b6d1d1e72e3bc1ac0c385fffb2dedc.svg";
export { ForwardRef as ReactComponent };